import React, { useState, useEffect } from 'react';
import { useMediaQuery } from 'react-responsive';
import { Box, PolymorphicComponentProps } from 'react-polymorphic-box';

const defaultElement = 'div';

type ReadMoreProps<E extends React.ElementType> = PolymorphicComponentProps<
  E,
  {
    mobileLength: number;
    desktopLength: number;
    fullContent?: string | null;
    dotOnly?: boolean;
    content: string;
    readMoreClass?: string;
    readMoreText?: string;
  }
>;

const ReadMore: <E extends React.ElementType = typeof defaultElement>(
  props: ReadMoreProps<E>
) => JSX.Element = (props) => {
  const { mobileLength, desktopLength, fullContent, dotOnly, content, readMoreClass, readMoreText, ...restProps } = props;
  const isDesktop = useMediaQuery({ minWidth: 768 });
  const [innerHtml, setInnerHtml] = useState({
    __html: content,
  });
  const [isShorten, setIsShorten] = useState(false);

  const limitChars = isDesktop ? desktopLength : mobileLength;
  const reveal = () => {
    setInnerHtml({ __html: fullContent || content });
    setIsShorten(false);
  };

  useEffect(() => {
    if (content.length < limitChars) {
      if (fullContent) {
        setInnerHtml({ __html: fullContent });
      }
      setIsShorten(false);
      return;
    }
    let index = limitChars - 1;
    while (content.charAt(index) !== ' ') {
      index = index - 1;
    }
    let shortenContent = content.substring(0, index);
    setInnerHtml({ __html: shortenContent });
    setIsShorten(true);
  }, [content, limitChars]);

  return (
    <Box as={defaultElement} {...restProps}>
      <span dangerouslySetInnerHTML={innerHtml} />
      {isShorten ? (
        <span onClick={() => (dotOnly ? null : reveal())}>
          ...
          {!dotOnly && <span className={readMoreClass || 'tw-ml-1 tw-cursor-pointer tw-text-brand-navy tw-lowercase tw-underline'}>{readMoreText || 'Read More'}</span>}
        </span>
      ) : (
        ''
      )}
    </Box>
  );
};

export default ReadMore;
